import Navbar from "../components/Navbar";
import Footer from '../components/Footer';
import ContactForm from '../components/ContactForm';
import BackToTop from '../components/BackToTop';

export default function Contact() {
    return (
        <>
            <Navbar />
            <ContactForm />
            <Footer />
            <BackToTop />
        </>
    );
}